import { IInference, IAstNode } from './typings';
import { TypeGenerator, isShallowEquals, isStringLike, isDigit, isDateTimeLike, isId, isEnum, isString } from '../utils/type';
import { InferenceError } from '../errors';


export function inferenceLogicComparison(inference: IInference, astNode: IAstNode) {
  const leftType = inference(astNode.left)!;
  const operator = astNode.operator!;
  const token = astNode.token;

  if (['BETWEEN', 'ALL-BETWEEN', 'ANY-BETWEEN'].includes(operator)) {

    // 单值比较
    if (operator === 'BETWEEN') {
      if (!isDigit(leftType, false) && !isDateTimeLike(leftType, false)) {
        throw new InferenceError('comparison-value-error', '非数字和时间类型不能参与 between and 表达式 的运算', token.position);
      }
    }
    // 数组与单值比较
    else if (['ALL-BETWEEN', 'ANY-BETWEEN'].includes(operator)) {

      if (!leftType.isArray) {
        throw new InferenceError('comparison-value-error', '比较符左侧必须为数组类型', token.position);
      }

      if (!isDigit(leftType, true) && !isDateTimeLike(leftType, true)) {
        throw new InferenceError('comparison-value-error', '非数字和时间类型不能参与 between and 表达式 的运算', token.position);
      }
    }

    const andLeftType = inference(astNode.andLeft)!;
    if (!isDigit(andLeftType, false) && !isDateTimeLike(andLeftType, false)) {
      throw new InferenceError('comparison-value-error', '非数字和时间类型不能参与 between and 表达式 的运算', token.position);
    }

    const andRightType = inference(astNode.andRight)!;
    if (!isDigit(andRightType, false) && !isDateTimeLike(andRightType, false)) {
      throw new InferenceError('comparison-value-error', '非数字和时间类型不能参与 between and 表达式 的运算', token.position);
    }

    if (!isShallowEquals([leftType, andLeftType, andRightType])) {
      throw new InferenceError('comparison-value-error', 'between and 表达式参与的数据类型必须相匹配', token.position);
    }
  }

  else if (['CONTAIN', 'NOT-CONTAIN', 'BEGIN-WITH', 'END-WITH'].includes(operator)) {
    const oRightType = inference(astNode.right)!;
    if (!isStringLike(leftType, false)) {
      throw new InferenceError('comparison-value-error', '非 String,Email,Url,PhoneNr 类型不能参与比较', token.position);
    }
    if (!isStringLike(oRightType, false)) {
      throw new InferenceError('comparison-value-error', '非 String,Email,Url,PhoneNr 类型不能参与比较', token.position);
    }
  }

  else if ([
    'ALL-CONTAIN', 'ALL-NOT-CONTAIN', 'ALL-BEGIN-WITH', 'ALL-END-WITH',
    'ANY-CONTAIN', 'ANY-NOT-CONTAIN', 'ANY-BEGIN-WITH', 'ANY-END-WITH'].includes(operator)) {
    const oRightType = inference(astNode.right)!;

    if (!leftType.isArray) {
      throw new InferenceError('comparison-value-error', '比较符左侧必须为数组类型', token.position);
    }

    if (!isStringLike(leftType, true)) {
      throw new InferenceError('comparison-value-error', '非 String,Email,Url,PhoneNr 类型不能参与比较', token.position);
    }
    if (!isStringLike(oRightType, false)) {
      throw new InferenceError('comparison-value-error', '非 String,Email,Url,PhoneNr 类型不能参与比较', token.position);
    }
  }

  else if (['IN', 'NOT-IN'].includes(operator)) {
    const oRightType = inference(astNode.right)!;
    if (isId(leftType, false)) {
      if (!isId(oRightType, true)) {
        throw new InferenceError('comparison-value-error', `${operator} 操作符右侧必须为Id数组类型`, token.position);
      }
      return TypeGenerator.Boolean();
    }

    if (isEnum(leftType, false)) {
      if (!isString(oRightType, true) && !isEnum(oRightType, true)) {
        throw new InferenceError('comparison-value-error', `${operator} 操作符右侧必须为String或Enum数组类型`, token.position);
      }
      return TypeGenerator.Boolean();
    }


    if (isString(leftType, false)) {
      if (!isString(oRightType, true)) {
        throw new InferenceError('comparison-value-error', `${operator} 操作符右侧必须为String数组类型`, token.position);
      }
      return TypeGenerator.Boolean();
    }

    throw new InferenceError('comparison-value-error', `${operator} 操作符左侧必须为Id、Enum或String类型`, token.position);
  }

  else if (['INCLUDE-ALL', 'INCLUDE-ANY', 'EXCLUDE-ALL', 'EXCLUDE-ANY'].includes(operator)) {
    const oRightType = inference(astNode.right)!;

    if (leftType.type !== oRightType.type || (!leftType.isArray) !== (!oRightType.isArray)) {
      throw new InferenceError('comparison-value-error', `${operator} 操作符只能用于IdArray和StringArray类型之间的比较`, token.position);
    }

    if (!isId(leftType, true) && !isString(leftType, true)) {
      throw new InferenceError('comparison-value-error', `${operator} 操作符只能用于IdArray和StringArray类型之间的比较`, token.position);
    }
    if (!isId(oRightType, true) && !isString(oRightType, true)) {
      throw new InferenceError('comparison-value-error', `${operator} 操作符只能用于IdArray和StringArray类型之间的比较`, token.position);
    }
  }

  return TypeGenerator.Boolean();
}
